import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Activity, DollarSign, Zap, Shield, Code } from "lucide-react";

const metrics = [
  { label: "Production Code", value: 195000, suffix: "+", icon: Code, color: "text-swarm-green" },
  { label: "Automated Tests", value: 297, suffix: "+", icon: Activity, color: "text-swarm-cyan" },
  { label: "API Endpoints", value: 150, suffix: "", icon: Zap, color: "text-swarm-violet" },
  { label: "Connectors", value: 39, suffix: "", icon: Shield, color: "text-swarm-green" },
  { label: "Features Shipped", value: 121, suffix: "", icon: DollarSign, color: "text-swarm-cyan" }
];

const AnimatedNumber = ({ value, prefix = "", suffix = "" }) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const increment = value / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= value) {
        setDisplayValue(value);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [value]);

  const formattedValue = displayValue.toLocaleString();

  return (
    <span className="font-mono font-bold tabular-nums">
      {prefix}{formattedValue}{suffix}
    </span>
  );
};

export const MetricsTicker = () => {
  return (
    <div 
      className="relative border-y border-swarm-border bg-swarm-darker/60 backdrop-blur-md overflow-hidden"
      data-testid="metrics-ticker"
    >
      {/* Gradient overlays for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-swarm-darker to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-swarm-darker to-transparent z-10 pointer-events-none" />
      
      <Marquee
        gradient={false}
        speed={40}
        pauseOnHover={true}
        className="py-4"
      >
        {[...metrics, ...metrics].map((metric, index) => (
          <div
            key={index}
            className="flex items-center gap-3 mx-8"
          >
            <div className={`p-2 rounded-lg bg-white/5 ${metric.color}`}>
              <metric.icon className="w-4 h-4" />
            </div>
            <div className="flex items-baseline gap-2">
              <span className={`text-xl ${metric.color}`}>
                <AnimatedNumber 
                  value={metric.value} 
                  prefix={metric.prefix} 
                  suffix={metric.suffix}
                />
              </span>
              <span className="text-slate-500 text-sm font-medium">
                {metric.label}
              </span>
            </div>
            <span className="text-slate-700 mx-4">|</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default MetricsTicker;
